// External
import { Injectable } from '@angular/core';

// Internal
import { ValuesService } from '../../../../common/values/values.service';
import { CheckoutSdkService } from '../../core/checkout-sdk.service';

@Injectable({
    providedIn: 'root'
})

export class ICheckoutSdkService {

    constructor(
        private readonly checkoutSdkService: CheckoutSdkService,
        private readonly valuesService: ValuesService
    ) { }

    /**
     * Creates the billing details interface
     */
    public createBillingDetailsInterface(): void {
        const billingDetailsInterface = {
            name: `${this.checkoutSdkService.getBillingDetailsFirstName()} ${this.checkoutSdkService.getBillingDetailsLastName()}`,
            address: this.checkoutSdkService.getBillingDetailsAddress(),
            country_name: this.computeCountryName()
        };
        const billingDetails = this.checkoutSdkService.getBillingDetails();
        billingDetails.interface = billingDetailsInterface;
    }

    /**
     * Computes the country name based in country code
     * @returns {string} The country name
     */
    private computeCountryName(): string {
        const countryCode = this.checkoutSdkService.getBillingDetailsCountryCode();
        for (const country of this.valuesService.zuoraCountriesISO) {
            if (country.key === countryCode) {
                return country.value;
            }
        }
        return '';
    }

    /**
     * Gets the billing details full name
     * @returns {string} The billing details full name
     */
    public getBillingDetailsName(): string {
        const billingDetails = this.checkoutSdkService.getBillingDetails();
        return billingDetails?.interface?.name;
    }

    /**
     * Gets the billing details address
     * @returns {string} The billing details address
     */
    public getBillingDetailsAddress(): string {
        const billingDetails = this.checkoutSdkService.getBillingDetails();
        return billingDetails?.interface?.address;
    }

    /**
     * Gets the billing details country name
     * @returns {string} The billing details country name
     */
    public getBillingDetailsCountryName(): string {
        const billingDetails = this.checkoutSdkService.getBillingDetails();
        return billingDetails?.interface?.country_name;
    }
}
